import { render, staticRenderFns } from "./CountrySettingDetail.vue?vue&type=template&id=13a3a0b8&scoped=true"
import script from "./CountrySettingDetail.vue?vue&type=script&lang=js"
export * from "./CountrySettingDetail.vue?vue&type=script&lang=js"
import style0 from "./CountrySettingDetail.vue?vue&type=style&index=0&id=13a3a0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3a0b8",
  null
  
)

export default component.exports